import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import hu from 'vuetify/lib/locale/hu';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1d0e30',
        secondary: '#c8c7cc',
        accent: '#82B1FF',
        error: '#c22f2f',
        info: '#2f90c2',
        success: '#93C22F',
        warning: '#c27f2f',
      },
      dark: {
        primary: '#fff',
        secondary: '#c8c7cc',
        accent: '#82B1FF',
        error: '#c22f2f',
        info: '#2f90c2',
        success: '#93C22F',
        warning: '#c27f2f',
      },
    },
  },
  lang: {
    locales: { hu },
    current: 'hu',
  },
  icons: {
    iconfont: 'fa',
  },
});
